// Role-based menu definition
import {
  LayoutDashboard, Users, Calendar, ClipboardList,
  Pill, FlaskConical, ScanLine, Receipt, Sparkles, BellRing,
  Building2, ShieldCheck, Briefcase, BarChart3, History, Settings,
} from "lucide-react";

export const ALL_NAV = [
  { to: "/app", label: "Dashboard", icon: LayoutDashboard, roles: "*" },
  { to: "/app/admin", label: "Control Center", icon: ShieldCheck, roles: ["super_admin"] },
  { to: "/app/tenants", label: "Doctor Tenants", icon: Building2, roles: ["super_admin"] },
  { to: "/app/patients", label: "Patients", icon: Users,
    roles: ["clinic_owner","admin","receptionist","doctor","nurse","accountant","lab_tech","radiologist","pharmacist"] },
  { to: "/app/appointments", label: "Appointments", icon: Calendar,
    roles: ["clinic_owner","admin","receptionist","doctor","nurse","patient"] },
  { to: "/app/calendar", label: "Calendar", icon: Calendar,
    roles: ["clinic_owner","admin","receptionist","doctor","nurse"] },
  { to: "/app/emr", label: "Medical Records", icon: ClipboardList,
    roles: ["clinic_owner","admin","doctor","nurse","patient"] },
  { to: "/app/prescriptions", label: "Prescriptions", icon: Pill,
    roles: ["clinic_owner","admin","doctor","pharmacist","patient"] },
  { to: "/app/laboratory", label: "Laboratory", icon: FlaskConical,
    roles: ["clinic_owner","admin","doctor","lab_tech","nurse","patient"] },
  { to: "/app/radiology", label: "Radiology", icon: ScanLine,
    roles: ["clinic_owner","admin","doctor","radiologist","nurse","patient"] },
  { to: "/app/pharmacy", label: "Pharmacy", icon: Pill,
    roles: ["clinic_owner","admin","pharmacist","doctor"] },
  { to: "/app/billing", label: "Billing & Invoices", icon: Receipt,
    roles: ["clinic_owner","admin","accountant","receptionist","doctor","patient"] },
  { to: "/app/ai", label: "AI Assistant", icon: Sparkles,
    roles: ["clinic_owner","admin","doctor","nurse"] },
  { to: "/app/inquiries", label: "Booking Inquiries", icon: BellRing,
    roles: ["clinic_owner","admin","doctor","receptionist"] },
  { to: "/app/site", label: "My Public Site", icon: Building2,
    roles: ["clinic_owner","admin","doctor"] },
  { to: "/app/hr", label: "Staff", icon: Briefcase,
    roles: ["clinic_owner","admin","hr","doctor"] },
  { to: "/app/reports", label: "Reports", icon: BarChart3,
    roles: ["clinic_owner","admin","accountant","doctor"] },
  { to: "/app/activity", label: "Activity Logs", icon: History,
    roles: ["super_admin","clinic_owner","admin"] },
  { to: "/app/settings", label: "Settings", icon: Settings, roles: "*" },
];

export function navForRole(role) {
  return ALL_NAV.filter((n) => n.roles === "*" || n.roles.includes(role));
}

export const ROLE_LABELS = {
  super_admin: "Platform Owner",
  clinic_owner: "Clinic Owner",
  admin: "Admin",
  receptionist: "Receptionist",
  doctor: "Doctor",
  nurse: "Nurse",
  lab_tech: "Lab Technician",
  radiologist: "Radiologist",
  pharmacist: "Pharmacist",
  accountant: "Accountant",
  hr: "HR Manager",
  patient: "Patient",
};
